import axios from 'axios';
import { getServerCore, defaultSnackbarTimeout } from '../../../utils';
import { showSuccessSnackbar } from '../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const defaultUrl = serverUrls.getDefaulUrl();

export const EthereumMap = {
    ACCOUNT_CONNECTED_SUCCESS: "ACCOUNT_CONNECTED_SUCCESS",
    ACCOUNT_CONNECTED_ERROR: "ACCOUNT_CONNECTED_ERROR",
    ACCOUNTS_CHANGED_SUCCESS: "ACCOUNTS_CHANGED_SUCCESS",
    CHAIN_CHANGED_SUCCESS: "CHAIN_CHANGED_SUCCESS",
    CHAIN_CHANGED_ERROR: "CHAIN_CHANGED_ERROR",
    NETWORK_CHANGED_SUCCESS: "NETWORK_CHANGED_SUCCESS",
    LOADER_SUCCESS: "LOADER_SUCCESS",
    // TOGGLE_MODAL: "TOGAL_MODAL",
    RESET_APP: "RESET_APP",

    PURCHASE_GOLD_START: 'PURCHASE_GOLD_START',
    PURCHASE_GOLD_SUCCESS: 'PURCHASE_GOLD_SUCCESS',
    PURCHASE_GOLD_ERROR: 'PURCHASE_GOLD_ERROR',

    GET_ALL_PURCHASE_GOLD_ORDER_BYID_START: 'GET_ALL_PURCHASE_GOLD_ORDER_BYID_START',
    GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS: 'GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS',
    GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR: 'GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR',
};

export const updateAccountStatusAsync = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: EthereumMap.ACCOUNT_CONNECTED_SUCCESS,
                payload,
            });
        } catch (error) {
            dispatch({
                type: EthereumMap.ACCOUNT_CONNECTED_ERROR,
            });
        }
    };
};

export const accountChangedAsync = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: EthereumMap.ACCOUNTS_CHANGED_SUCCESS,
                payload: payload,
            });
        } catch (error) {
            console.log(error);
        }
    };
};

export const chainChangedAsync = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: EthereumMap.CHAIN_CHANGED_SUCCESS,
                payload: payload,
            });
        } catch (error) {
            console.log(error);
        }
    };
};

export const networkChangedAsync = (payload) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: EthereumMap.NETWORK_CHANGED_SUCCESS,
                payload: payload,
            });
        } catch (error) {
            console.log(error);
        }
    };
};

export const loaderStatusAsync = (payload) => {
    return async (dispatch) => {
        dispatch({
            type: EthereumMap.LOADER_SUCCESS,
            payload,
        });
    };
};

export const resetAppAsync = () => {
    return async (dispatch) => {
        dispatch({
            type: EthereumMap.RESET_APP,
        });
    };
};

export const BuyGoldAction = {
    purchaseGoldStart: () => ({ type: EthereumMap.PURCHASE_GOLD_START }),
    purchaseGoldSuccess: (data) => ({ type: EthereumMap.PURCHASE_GOLD_SUCCESS, payload: data }),
    purchaseGoldError: () => ({ type: EthereumMap.PURCHASE_GOLD_ERROR }),

    getAllPurchaseGoldOrderByIdStart: () => ({ type: EthereumMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_START }),
    getAllPurchaseGoldOrderByIdSuccess: (data) => ({ type: EthereumMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_SUCCESS, payload: data }),
    getAllPurchaseGoldOrderByIdError: () => ({ type: EthereumMap.GET_ALL_PURCHASE_GOLD_ORDER_BYID_ERROR }),
}

export const buyPurchaseGoldAsync = (goldOrder) => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(BuyGoldAction.purchaseGoldStart());
            const { data } = await axios({
                method: 'POST',
                url: `${defaultUrl}/user/purchase/${_id}`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: goldOrder
            })
            if (data.responseCode === 200) {
                dispatch(BuyGoldAction.purchaseGoldSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(BuyGoldAction.purchaseGoldError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(BuyGoldAction.purchaseGoldError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const getAllPurchaseGoldOrderByIdAsync = () => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdStart());
            const { data } = await axios({
                method: 'GET',
                url: `${defaultUrl}/user/getAllPurchaseGoldOrderById/${_id}`,
            })
            if (data.responseCode === 200) {
                dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdSuccess(data.responseData));
                dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            } else {
                dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdError());
                dispatch(showSuccessSnackbar('error', data.responseMessage, defaultSnackbarTimeout));
            }
        } catch (error) {
            dispatch(BuyGoldAction.getAllPurchaseGoldOrderByIdError(error.message));
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

